<template lang="html">
  <div class="">
    <v-row justify="center">
      <v-col cols="10" class="text-center">
        <h1>A soroban</h1>
        <transition name="slide" mode="out-in">
          <div v-if="showDescription">
            <p>
              Ez egy animált soroban, mindössze 8 rúddal.<br/>
              Az eredetin több rúd (páratlan számú) található, többnyire 13, és minden harmadik oszlop meg van jelölve.<br/>
              Az oldalon használt animációkon az egyszerűség kedvéért a legelső jobboldali oszlopon vannak az 'egyesek', nem használunk tized/század stb értékeket.
            </p>
            <p>
              A gyöngyök kattintással mozgathatók. A beviteli mezőbe írt számokat a soroban kijelzi.
            </p>
            <p>
              Az egyes animációk lejátszása alatt az oldal nem navigálható (csak újratölthető).
            </p>
            <v-icon @click="showDescription=!showDescription">mdi-chevron-up</v-icon>
          </div>
        </transition>

        <v-icon v-if="!showDescription" @click="showDescription=!showDescription">mdi-chevron-down</v-icon>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="7">
        <Soroban :clickDisabled="animationOn"/>
      </v-col>

      <v-col cols="12" md="5" class="text-center">
        <v-btn :disabled="$store.state.animationRunning" class="primary" @click="animationOn=!animationOn">{{animationOn ? 'Vissza a játszóházba' : 'Animációk'}}
          <v-icon>mdi-arrow-right</v-icon>
        </v-btn>
        <Animation v-if="animationOn" />
        <Controller v-if="!animationOn"/>
      </v-col>
    </v-row>


  </div>
</template>

<script>
import Soroban from '@/components/Soroban/SorobanFull.vue'
import Animation from '@/components/Animation/Animation.vue'
import Controller from '@/components/Controller.vue'

export default {
  data(){
    return{
      animationOn: false,
      showDescription: true,
    }
  },
  components: {
    Soroban,
    Animation,
    Controller,
  },
}
</script>

<style lang="scss" scoped>

</style>
